import { QRCodeSVG } from 'qrcode.react';

export interface QRProps {
  value: string;
  size?: number;
  className?: string;
}

/** QR code rendered in ink-on-paper to match the design language. */
export function QR({ value, size = 132, className }: QRProps) {
  return (
    <div
      className={className}
      style={{ background: '#fff', padding: 10, borderRadius: 'var(--r-sm)', lineHeight: 0 }}
    >
      <QRCodeSVG value={value} size={size} fgColor="#1c1b19" bgColor="#ffffff" level="M" />
    </div>
  );
}
